import { useTranslation } from "react-i18next";
import Icon from "../components/Icon";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import { TESTIMONIALS } from "../data/trust";
import { useL } from "../lib/useLang";

const initials = (name) =>
  name
    .split(" ")
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export default function Testimonials() {
  const { t } = useTranslation();
  const L = useL();

  return (
    <section
      className="fsg-section fsg-section--ink fsg-testimonials-section"
      id="testimonios"
    >
      <div className="fsg-container">
        <SectionHead
          eyebrow={t("testimonials.eyebrow")}
          title={t("testimonials.title")}
          lead={t("testimonials.lead")}
          center
        />

        <div className="fsg-grid fsg-grid--4">
          {TESTIMONIALS.map((item, index) => (
            <Reveal className="fsg-quote" key={item.id} delay={index * 60}>
              <div
                className="fsg-quote__stars"
                role="img"
                aria-label={`${item.rating} ${t("testimonials.of5")}`}
              >
                {Array.from({ length: item.rating }).map((_, starIndex) => (
                  <Icon key={starIndex} name="star" />
                ))}
              </div>
              <blockquote>“{L(item.quote)}”</blockquote>
              <div className="fsg-quote__person">
                <span className="fsg-avatar" aria-hidden="true">
                  {initials(item.name)}
                </span>
                <span>
                  <strong>{item.name}</strong>
                  <span>{L(item.role)}</span>
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <p
          className="fsg-hint"
          style={{ marginTop: "var(--fsg-s-5)", textAlign: "center" }}
        >
          {t("testimonials.note")}
        </p>
      </div>
    </section>
  );
}
